import { NavLink } from "react-router-dom";

const TONES = {
  light: {
    bar: "bg-white/95 border-stone-soft",
    idle: "text-ink/55",
    active: "text-forest",
    pill: "bg-forest/10",
  },
  dark: {
    bar: "bg-ink/95 border-white/10",
    idle: "text-cream/60",
    active: "text-amber-warm",
    pill: "bg-white/10",
  },
};

// Navigasi bawah ala aplikasi (hanya di layar < lg).
// items: [{ to, label, icon, end?, badge?, onClick? }] — item tanpa `to` dirender sebagai tombol.
export default function MobileTabBar({ items, tone = "light", testIdPrefix = "tab" }) {
  const t = TONES[tone];

  const body = (Icon, label, badge, active) => (
    <>
      <span className={`relative h-8 w-14 grid place-items-center rounded-full transition-colors ${active ? t.pill : ""}`}>
        <Icon size={21} strokeWidth={active ? 2.3 : 1.9} />
        {badge > 0 && (
          <span className="absolute -top-0.5 right-2 bg-terracotta text-white text-[10px] font-bold min-w-[17px] h-[17px] px-1 grid place-items-center rounded-full leading-none">
            {badge > 99 ? "99+" : badge}
          </span>
        )}
      </span>
      <span className={`text-[11px] leading-[1.25] mt-0.5 truncate max-w-full ${active ? "font-semibold" : "font-medium"}`}>{label}</span>
    </>
  );

  const cls = (active) => `flex flex-col items-center justify-center h-16 px-1 select-none transition-colors ${active ? t.active : t.idle}`;

  return (
    <nav
      className={`lg:hidden fixed bottom-0 inset-x-0 z-40 border-t backdrop-blur-md pb-safe ${t.bar}`}
      aria-label="Navigasi utama"
    >
      <ul className="grid" style={{ gridTemplateColumns: `repeat(${items.length}, minmax(0, 1fr))` }}>
        {items.map((it) => {
          const testId = `${testIdPrefix}-${it.label.toLowerCase().replace(/\s+/g, "-")}`;
          return (
            <li key={it.label}>
              {it.to ? (
                <NavLink to={it.to} end={it.end} className={({ isActive }) => cls(isActive)} data-testid={testId}>
                  {({ isActive }) => body(it.icon, it.label, it.badge, isActive)}
                </NavLink>
              ) : (
                <button type="button" onClick={it.onClick} className={`${cls(it.active)} w-full`} data-testid={testId}>
                  {body(it.icon, it.label, it.badge, it.active)}
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
